import React, { useState } from "react"
import Skeleton from "@material-ui/lab/Skeleton"

import { Loading } from "@/components"

import useDidMount from "@/hooks/useDidMount"

export type ImageProps = {
	src: string
	alt: string
	classes?: {
		afterLoad?: string
		beforeLoad?: string
	}
}

const Image: React.FC<ImageProps> = (props) => {
	const { alt, classes, src } = props

	const [loaded, setLoaded] = useState(false)

	const initialize = () => {
		const imageElement = document.createElement("img")

		imageElement.onload = () => setLoaded(true)

		imageElement.onerror = () => setLoaded(true)

		imageElement.src = src
	}

	useDidMount(() => {
		initialize()
	})

	return (
		<Loading
			loading={!loaded}
			customLoadingElement={(
				<Skeleton
					variant="rect"
					className={classes?.beforeLoad}
				/>
			)}
		>
			<img
				src={src}
				alt={alt}
				className={classes?.afterLoad}
			/>
		</Loading>
	)
}

export default Image
